import * as yup from "yup";

const schema = {
  tosAccept: yup.boolean().oneOf([true], "This field must be checked"),
};

export default schema;
